module.exports = __webpack_public_path__ + "img/r-23.8d5240ef.jpg";